/**
 * Recursively transform 'data-odxlayout' attributes to 'odxlayout' attributes within a given element.
 * @param element The starting element to transform attributes within.
 */
function transformOdxLayout(element: HTMLElement): void {
    // Check if the current element has the 'data-odxlayout' attribute.
    const dataOdxlayout = element.getAttribute("data-odxlayout");
    if (dataOdxlayout) {
        element.setAttribute("odxlayout", dataOdxlayout);
        element.removeAttribute("data-odxlayout");
    }

    // Recursively transform child elements.
    const childElements = element.querySelectorAll("[data-odxlayout]");
    childElements.forEach((childElement) => {
        transformOdxLayout(childElement as HTMLElement);
    });
}

/**
 * Call this function with a reference to the root element where 'data-odxlayout' attributes should be transformed.
 * @param ref The reference to the root (div) element.
 */
export function transformOdxLayoutRef(ref: HTMLDivElement): void {
    if (!ref) return;
    transformOdxLayout(ref);
}